// extracted by mini-css-extract-plugin
export var danger = "_3u-6";
export var lightPink = "_3u-a";
export var medium = "_3u-j";
export var nearSquare = "_3u-m";
export var neutralBlue = "_3u-8";
export var neutralYellow = "_3u-7";
export var noCapitalize = "_3u-1";
export var normal = "_3u-2";
export var pill = "_3u-0";
export var primary = "_3u-3";
export var primaryLight = "_3u-4";
export var shadow = "_3u-n";
export var small = "_3u-k";
export var solidBlack = "_3u-i";
export var solidGreen = "_3u-d";
export var solidLightBlue = "_3u-f";
export var solidNavy = "_3u-e";
export var solidOrange = "_3u-h";
export var solidPink = "_3u-g";
export var solidRed = "_3u-b";
export var solidWhite = "_3u-9";
export var solidYellow = "_3u-c";
export var success = "_3u-5";
export var xsmall = "_3u-l";